import type { Template } from "@/types";

export const LA_04_H1_V3: Template[] = [
    {
        id: "la-04-h1v3-01",
        name: "LA 01 - H1V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h1_v3_01.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 148, y: 0, width: 380, height: 541, rotation: 0, imageRotation: 0 },
            { id: "2", x: 849, y: 61, width: 308, height: 199, rotation: 0, imageRotation: 0 },
            { id: "3", x: 849, y: 268, width: 151, height: 210, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1008, y: 268, width: 150, height: 210, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h1v3-02",
        name: "LA 02 - H1V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h1_v3_02.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 93, y: 54, width: 285, height: 432, rotation: 0, imageRotation: 0 },
            { id: "2", x: 385, y: 54, width: 200, height: 130, rotation: 0, imageRotation: 0 },
            { id: "3", x: 385, y: 192, width: 200, height: 294, rotation: 0, imageRotation: 0 },
            { id: "4", x: 860, y: 54, width: 309, height: 432, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h1v3-03",
        name: "LA 03 - H1V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h1_v3_03.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 191, y: 54, width: 294, height: 433, rotation: 0, imageRotation: 0 },
            { id: "2", x: 855, y: 54, width: 312, height: 199, rotation: 0, imageRotation: 0 },
            { id: "3", x: 855, y: 261, width: 153, height: 225, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1016, y: 261, width: 152, height: 225, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h1v3-04",
        name: "LA 04 - H1V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h1_v3_04.png",
        size: [1352, 541],
        style: {},
        slots: [      
            { id: "1", x: 46, y: 122, width: 190, height: 295, rotation: 0, imageRotation: 0 },
            { id: "2", x: 244, y: 122, width: 189, height: 295, rotation: 0, imageRotation: 0 },
            { id: "3", x: 441, y: 122, width: 189, height: 295, rotation: 0, imageRotation: 0 },
            { id: "4", x: 722, y: 54, width: 584, height: 432, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h1v3-05",
        name: "LA 05 - H1V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h1_v3_05.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 104, y: 113, width: 468, height: 306, rotation: 0, imageRotation: 0 },
            { id: "2", x: 782, y: 43, width: 301, height: 457, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1090, y: 43, width: 156, height: 225, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1090, y: 276, width: 156, height: 224, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h1v3-06",
        name: "LA 06 - H1V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h1_v3_06.png",
        size: [1352, 541],
        style: {},
        slots: [   
            { id: "1", x: 182, y: 55, width: 152, height: 222, rotation: 0, imageRotation: 0 },
            { id: "2", x: 182, y: 285, width: 311, height: 202, rotation: 0, imageRotation: 0 },
            { id: "3", x: 342, y: 55, width: 152, height: 222, rotation: 0, imageRotation: 0 },
            { id: "4", x: 859, y: 55, width: 310, height: 430, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "la-04-h1v3-07",
        name: "LA 07 - H1V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h1_v3_07.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 120, y: 62, width: 280, height: 418, rotation: 0, imageRotation: 0 },
            { id: "2", x: 407, y: 62, width: 142, height: 205, rotation: 0, imageRotation: 0 },
            { id: "3", x: 407, y: 274, width: 142, height: 206, rotation: 0, imageRotation: 0 },
            { id: "4", x: 719, y: 62, width: 589, height: 418, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h1v3-08",
        name: "LA 08 - H1V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h1_v3_08.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 43, y: 62, width: 589, height: 418, rotation: 0, imageRotation: 0 },
            { id: "2", x: 794, y: 62, width: 282, height: 418, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1083, y: 62, width: 140, height: 205, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1083, y: 274, width: 140, height: 206, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h1v3-09",
        name: "LA 09 - H1V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h1_v3_09.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 43, y: 78, width: 236, height: 384, rotation: 0, imageRotation: 0 },
            { id: "2", x: 287, y: 78, width: 236, height: 384, rotation: 0, imageRotation: 0 },
            { id: "3", x: 531, y: 78, width: 236, height: 384, rotation: 0, imageRotation: 0 },
            { id: "4", x: 775, y: 78, width: 533, height: 384, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h1v3-10",
        name: "LA 10 - H1V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h1_v3_10.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 43, y: 78, width: 236, height: 384, rotation: 0, imageRotation: 0 },
            { id: "2", x: 287, y: 78, width: 533, height: 384, rotation: 0, imageRotation: 0 },
            { id: "3", x: 828, y: 78, width: 236, height: 384, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1072, y: 78, width: 236, height: 384, rotation: 0, imageRotation: 0 }
        ],
    }
];
